export default {
    install() {
        let timeout;
        const logoutTime = 6 * 60 * 60 * 1000; // 1 minute

        function resetTimer() {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                // Instead of alert, emit a custom event
                window.dispatchEvent(new Event('session-timeout'));
            }, logoutTime);
        }

        ['mousemove', 'keydown', 'click'].forEach(event => {
            document.addEventListener(event, resetTimer);
        });

        resetTimer();
    }
};
